import React from 'react';
import cart from '../assets/images/icons/cart-icon.png';



class Lab_Tests_Listing extends React.Component {
    constructor(props) {
        super(props);
        this.state = {};
    }
    render() {
        return (
            <>
                <li className="tests-listing-row">
                    <div className="tests-listing-box">
                        <div className="tests-list-heading-box">
                            <div className="heading-box">
                                <h2 className="font-18 weight-600 mb-0">{this.props.testsTitle}</h2>
                            </div>
                            <div className="price-box">
                                <span className="font-18 weight-700">{this.props.testsPrice}</span>
                            </div>
                        </div>
                        <div className="tests-detail-listing">
                            <div className="tests-inner-list">
                                <div className="other-detail-row">
                                    <div className="other-detail-col">
                                        <div className="other-detail-box">
                                            <p className="font-14  text-color-666">Sample Type</p>
                                            <span className="font-14 weight-500">{this.props.sampleType}</span>
                                        </div>
                                    </div>
                                    <div className="other-detail-col">
                                        <div className="other-detail-box">
                                            <p className="font-14 text-color-666">Processing Time</p>
                                            <span className="font-14 weight-500">{this.props.testProcessingTime}</span>
                                        </div>
                                    </div>
                                    <div className="other-detail-col">
                                        <div className="other-detail-box">
                                            <p className="font-14 text-color-666">Special Instruction</p>
                                            <span className="font-14 weight-500">{this.props.instruction}</span>
                                        </div>
                                    </div>
                                    <div className="other-detail-col">
                                        <div className="other-detail-box">
                                            <p className="font-14 text-color-666">Parameters Included</p>
                                            <span className="font-14 weight-500">{this.props.parameters}</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="detail-btn-area">
                                    <div class="cart-btn-box">
                                        <button class="cart-btn">
                                            <img src={cart} alt="Cart"/>
                                        </button>
                                    </div>
                                    <button class="book-now-btn main-btn">Book Now</button>
                                </div>
                            </div>
                            <div className="view-btn-box">
                                <span className="font-14 primary-text weight-500 text-underline">View More</span>
                            </div>
                            <div className="description-box">
                                <span class="font-14  text-color-666">Description</span>
                                <p class="font-14 weight-500">{this.props.descriptionText}</p>
                            </div>
                        </div>
                    </div>
                </li>
            </>
        );
    }
};

export default Lab_Tests_Listing;    